import Vue from "vue";

import moment from "moment";
Vue.prototype.moment = moment;

// * Axios
import axios from "axios";

// let axiosToken;

// /**
//  * Set Token, used when token is changed in store
//  * @param {String} token
//  */
// export const setAuthToken = token => {
//     axiosToken = token;
// };

// axios.defaults.transformRequest = data => {
//     if (data === null || data === undefined) {
//         return;
//     }
//     const formData = new FormData();
//     Object.keys(data).forEach(key => {
//         if (data[key] === undefined) {
//             return;
//         }
//         // Transform date to utc
//         if (data[key] instanceof Date) {
//             formData.append(
//                 key,
//                 moment(data[key])
//                     .utc()
//                     .format()
//             );
//             return;
//         }
//         // Transform arrays to array[]
//         if (Array.isArray(data[key])) {
//             data[key].forEach(item => {
//                 formData.append(key + "[]", item);
//             });
//             return;
//         }
//         formData.append(key, data[key]);
//     });
//     return formData;
// };
Vue.prototype.$axios = axios;
Vue.prototype.$http = axios;
// if (process.env.NODE_ENV === "production") {
//     Vue.prototype.$axios.defaults.baseURL =
//         "https://invoice-test-api.arcellatelecom.com/api-v1/panel";
// } else {
Vue.prototype.$axios.defaults.baseURL = "/api-v1/panel/";
// }
Vue.prototype.$axios.defaults.withCredentials = true;

// * vForm
import { /*Form,*/ HasError, AlertError } from "./vForm";
Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);
// Vue.prototype.Form = Form;

// * LocalForge
import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);

axios.interceptors.request.use(config => {
    if (process.env.NODE_ENV == "development")
        console.log("⬜ Request", config.url, config.data);
    // config.headers["x-localization"] = i18n.currentLocale();
    // config.headers["Accept-Language"] = i18n.currentLocale();
    config.headers["Authorization"] = Vue.prototype.$localStorage.get("token");
    return config;
});
axios.interceptors.response.use(undefined, error => {
    if (process.env.NODE_ENV == "development" && error.response) {
        console.log(
            "🔴 Response\nURL: ",
            error?.response?.config.url,
            "\nSTATUS:",
            error?.response?.status,
            "\nDATA: ",
            error?.response?.data
        );
        // return Promise.reject(error);
    }
    /** On Reject */
    if (error.response) {
        // Request made and server responded
        // Skip validate response handle
        if (error.response.config.url.indexOf("/validate") != -1) {
            return Promise.reject(error);
        }
        // * Checking Status Code
        switch (error.response.status) {
            // Authorization failed
            case 401:
                if (error.response.data?.error) {
                    location.href = "/";
                }
                return Promise.reject(error);
            case 400:
            case 403:
                Vue.prototype.$buefy.toast.open({
                    duration: 5000,
                    message: error.response.data.error,
                    position: "is-bottom",
                    type: "is-danger"
                });
                return Promise.reject(error);
            case 404:
                Vue.prototype.$buefy.toast.open({
                    duration: 5000,
                    message: "Requested resource not found",
                    position: "is-bottom",
                    type: "is-danger"
                });
                return Promise.reject(error);
            // Data entry error
            case 422:
                Vue.prototype.$buefy.toast.open({
                    duration: 5000,
                    message: `Input error`,
                    position: "is-bottom",
                    type: "is-danger"
                });
                // showToast(i18n.t('input-error'), 'danger');
                return Promise.reject(error);
        }
        // * Firing Error Message
        // if (error.response.data?.error) {
        //     // If has error object inside response
        //     showToast(error.response.data.error, "danger");
        // } else {
        //     // Network error
        //     showToast(i18n.t("500-error"), "danger");
        // }
    } else if (error.request) {
        // The request was made but no response was received
        // Vue.prototype.$notify(error.message);
        // console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        if (process.env.NODE_ENV == "development")
            console.log("Error", error.message);
    }
    Vue.prototype.$buefy.toast.open({
        duration: 5000,
        message: "There were something wrong." + error,
        position: "is-bottom",
        type: "is-danger"
    });

    return Promise.reject(error);
});

// Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDrOz38sqMqBDhIQvBlxmn1rOcXl0lC1tE",
        libraries: "places"
        //   libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)
    },

    // If you intend to programmatically custom event listener code
    // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    // you might need to turn this on.
    // autobindAllEvents: false,

    // If you want to manually install components, e.g.
    // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    // Vue.component('GmapMarker', GmapMarker)
    // then set installComponents to 'false'.
    // If you want to automatically install all the components this property must be set to 'true':
    installComponents: true
});
